"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("../../styles/baseForm.scss");
var themeLog = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var searchBar_1 = require("@vidazoo/ui/lib/components/searchBar");
var _ = require("lodash");
var components_1 = require("./components");
var moment = require("moment");
var LogsStore_1 = require("../../stores/LogsStore");
var inputEnterAction_1 = require("./components/inputEnterAction/inputEnterAction");
var lib_1 = require("../../lib");
var SearchBarEnterAction = inputEnterAction_1.default(searchBar_1.SearchBar);
var LogForm = /** @class */ (function (_super) {
    tslib_1.__extends(LogForm, _super);
    function LogForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onShowInfo = function (item) {
            _this.setState({ itemInfo: item });
        };
        _this.componentWillMount = function () {
            var match = _this.props.match;
            _this.logsStore.getItemsById(match.params.id);
        };
        _this.onSearch = function (e) {
            _this.logsStore.setSearch(e.target.value);
        };
        _this.onSearchClear = function () {
            _this.logsStore.setSearch("");
        };
        _this.onDateChange = function (from, to) {
            _this.logsStore.onDateChange(from, to);
        };
        _this.onClick = function () {
            var match = _this.props.match;
            _this.logsStore.getItemsById(match.params.id);
        };
        _this.onGenerateLink = function (request, campaign) {
            var match = _this.props.match;
            _this.logsStore.generateLink(match.params.id, request, campaign);
        };
        _this.onCopyItem = function (key) {
            var itemInfo = _this.state.itemInfo;
            var value = itemInfo[key];
            lib_1.MemoryClipboard.copy((_.isObject(value) ? JSON.stringify(value, null, 4) : _this.tryJsonParse(value)));
        };
        _this.onDownloadItem = function (key) {
            var itemInfo = _this.state.itemInfo;
            var value = itemInfo[key];
            var blob = new Blob([value], { type: "text/plain" });
            var url = URL.createObjectURL(blob);
            var a = document.createElement("a");
            var date = moment().format("DD.MM.YY_HHmm");
            a.href = url;
            a.download = key + "_" + date + ".txt";
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        };
        _this.hideItemInfo = function () {
            _this.setState({ itemInfo: null });
        };
        _this.renderItemInfoItem = function (value, key) {
            return (React.createElement("div", { key: key, style: { marginBottom: "10px" } },
                React.createElement("div", { className: themeLog.log },
                    React.createElement("strong", null, key),
                    React.createElement(ui_1.LinkButton, { iconName: "icon-copy", iconSize: 2, gray: true, onClick: function () { return _this.onCopyItem(key); } }),
                    React.createElement(ui_1.LinkButton, { iconName: "icon-download", iconSize: 2, gray: true, onClick: function () { return _this.onDownloadItem(key); } })),
                React.createElement(ui_1.HLine, { topSpace: 1, bottomSpace: 1 }),
                React.createElement("div", { className: themeLog.log, style: { wordBreak: "break-all" } },
                    React.createElement("pre", { className: themeLog.pre, style: { whiteSpace: "pre-wrap" } }, (_.isObject(value) ? JSON.stringify(value, null, 4) : _this.tryJsonParse(value))))));
        };
        _this.downloadCsv = function () {
            _this.logsStore.downloadCSV();
        };
        _this.logsStore = new LogsStore_1.default(props.notificationsStore, props.exportToCsvService, props.filter, props.playerAction, props.prepareItems, _this.props.logItemType);
        _this.state = { itemInfo: null };
        return _this;
    }
    LogForm.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(ui_1.Loader, { size: 2, gray: true, className: theme.loader }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading Logs", description: "Please wait..." })));
    };
    LogForm.prototype.tryJsonParse = function (value) {
        try {
            return "" + JSON.stringify(JSON.parse(value), null, "\t");
        }
        catch (e) {
            return value;
        }
    };
    LogForm.prototype.renderItemInfo = function () {
        var itemInfo = this.state.itemInfo;
        return (React.createElement(ui_1.Modal, { panel: true, isOpen: true, onClose: this.hideItemInfo, title: itemInfo.name, windowStyle: { maxWidth: "60%" } }, _.map(tslib_1.__assign({}, itemInfo), this.renderItemInfoItem)));
    };
    LogForm.prototype.render = function () {
        var _a = this.logsStore, isLoading = _a.isLoading, filteredItems = _a.filteredItems, items = _a.items, sortBy = _a.sortBy, sort = _a.sort, sortDirection = _a.sortDirection, density = _a.density, setSearchQuery = _a.setSearchQuery, searchQueries = _a.searchQueries, search = _a.search, toDate = _a.toDate, fromDate = _a.fromDate, headers = _a.headers, itemKeys = _a.itemKeys;
        var itemInfo = this.state.itemInfo;
        var _b = this.props, playerAction = _b.playerAction, setColumnsWidth = _b.setColumnsWidth, getColumnsWidth = _b.getColumnsWidth;
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("div", { className: "flex" },
                    React.createElement(ui_1.Tooltip, { title: "For partial search use * - '*vidazoo*' instead of 'www.vidazoo.com'", position: "top", delay: 500 },
                        React.createElement(SearchBarEnterAction, { className: "flex-1", inner: true, placeholder: "Search", value: search, triggerOnEmpty: true, onEnter: this.onClick, onChange: this.onSearch, onClear: this.onSearchClear })),
                    React.createElement(ui_1.Spacer, { right: 20 }),
                    React.createElement(ui_1.DateTimeRangePicker, { onChange: this.onDateChange, toDate: toDate, fromDate: fromDate }),
                    React.createElement(ui_1.Spacer, { right: 20 }),
                    React.createElement(ui_1.IconButton, { type: "submit", disabled: isLoading, flat: true, blue: true, iconName: "icon-search", onClick: this.onClick }),
                    React.createElement(ui_1.IconButton, { iconName: "icon-download", flat: true, onClick: this.downloadCsv, style: { marginLeft: 10 } }))),
            React.createElement(ui_1.Spacer, { bottom: 20 }),
            React.createElement("div", { className: theme.form },
                (!isLoading && items && items.length) ? (React.createElement(components_1.LogFormList, { onShowInfo: this.onShowInfo, items: filteredItems, sortBy: sortBy, sortDirection: sortDirection, onSearch: setSearchQuery, onSort: sort, density: density, searchQueries: searchQueries, playerAction: playerAction, onGenerateLink: this.onGenerateLink, setColumnsWidth: setColumnsWidth, getColumnsWidth: getColumnsWidth, headers: headers, itemKeys: itemKeys })) : null,
                isLoading ? this.renderLoader() : null,
                itemInfo ? this.renderItemInfo() : null)));
    };
    LogForm.defaultProps = {};
    return LogForm;
}(React.Component));
exports.default = LogForm;
